import { render, staticRenderFns } from "./PackageUser.vue?vue&type=template&id=47c4c6fa"
import script from "./PackageUser.vue?vue&type=script&lang=js"
export * from "./PackageUser.vue?vue&type=script&lang=js"
import style0 from "./PackageUser.vue?vue&type=style&index=0&id=47c4c6fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports